var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.value && _vm.value.geo && _vm.value.geo.lat && _vm.value.geo.lng ? _c('partner-map', {
    attrs: {
      "coordinates": _vm.value.geo,
      "height": 265,
      "colour": "red"
    }
  }) : _vm._e(), _vm.value && (_vm.value.street || _vm.value.zip || _vm.value.city) ? _c('v-sheet', {
    attrs: {
      "rounded": "",
      "color": "grey lighten-4"
    }
  }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("mdi-map-marker-circle")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm.value.street ? _c('span', [_vm._v(" " + _vm._s(_vm.value.street) + ", "), _c('br')]) : _vm._e(), _vm.value.zip || _vm.value.city ? _c('span', [_vm._v(" " + _vm._s(_vm.value.zip) + " " + _vm._s(_vm.value.city) + " ")]) : _vm._e()])], 1), _c('v-list-item-action', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_vm.value && _vm.value.geo && _vm.value.geo.lat && _vm.value.geo.lng ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "href": "http://maps.google.com/?q=".concat(_vm.value.geo.lat, ",").concat(_vm.value.geo.lng),
            "target": "_blank",
            "icon": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-link-variant")])], 1) : _vm.value && _vm.value.street ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "href": "http://maps.google.com/?q=".concat(_vm.value.toString()),
            "target": "_blank",
            "icon": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-link-variant")])], 1) : _vm._e()];
      }
    }], null, false, 2791179168)
  }, [_c('span', [_vm._v("Google Maps")])])], 1)], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }